import { GroupDataBucket, GroupDataResponse } from '@front-app/services/GroupsApi/GroupDataModel';

export interface EchartsHookState {
	isEnhancedDashboard: boolean;
	groupIds: string[];
	categoryNames: string[];
	dateTimeStart: Date;
	dateTimeEnd: Date;
	bucketSize: GroupDataBucket;
	averagingWindowDays: number;
	aggregateGroups: boolean;
}

export enum DataPointName {
	DATE = 'date',
	CUMULATIVE_TOTAL = 'total',
	WINDOWED_AVERAGE = 'windowed_average',
	MEMBER_JOINS = 'memberJoins',
	MEMBER_LEAVES = 'memberLeaves',
	SHARE_UPLOADS = 'shareUploads',
	SHARE_REMOVES = 'shareRemoves',
	CREATE_DISCUSSION = 'createDiscussion',
	READ_DISCUSSION = 'readDiscussion',
	DISCUSSION_POSTS = 'discussion_posts',
	CREATE_EVENT = 'createEvent',
	FILE_DOWNLOADS = 'file_downloads',
	VIEW = 'view',
}

export type TimeseriesPoint = [number, number];

export type MappedDataResponse = Partial<Record<DataPointName, GroupDataResponse>>;

export interface DateData {
	date: Date;
	data: Record<DataPointName, number>;
	totalAtDate: number;
	windowedAverageAtDate: number;
}

export interface UseEchartWithData {
	update(): Promise<void>;
}
